import { connect } from 'react-redux'
import { compose } from 'recompose'
import {
  selectNewPrimaryResidenceDownPayment,
  selectNewPrimaryResidenceBudget,
  selectNewPrimaryResidenceMonthlyPayment
} from 'src/store/selectors/home/equity'
import { selectShowBuyersLink } from 'src/store/selectors/layout'
import { selectNewPrimaryResidenceMortgageRate } from 'src/store/selectors/mortgageRate'

const RentBuyContainer = compose(
  connect(state => ({
    showBuyersLink: selectShowBuyersLink(state),
    budget: selectNewPrimaryResidenceBudget(state),
    downPaymentAmount: selectNewPrimaryResidenceDownPayment(state),
    monthlyPayment: selectNewPrimaryResidenceMonthlyPayment(state),
    mortgageRate: selectNewPrimaryResidenceMortgageRate(state)
  }))
)

export default RentBuyContainer
